import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { FormDataService } from '@app/_core/services/form-data.service';
import { UserService } from '@app/_core/services/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrl: './file-uploader.component.scss'
})
export class FileUploaderComponent implements OnInit {
  @Input() title: any;
  @Input() allowedFileTypes: any;
  @Input() maxFileSize: any;
  @Output() handleFileUpload = new EventEmitter<any>();
  @Output() handleCancel = new EventEmitter<any>();
  
  file: File = null;
  files: any = [];
  blobData: any;
  fileID: any = '';
  ImageURL: any = '';
  savingFileMessage: any = '';
  appBaseUrl: any;
  URL: any = '';

  activeColor: string = 'green';
  baseColor: string = '#ccc';
  overlayColor: string = 'rgba(255,255,255,0.5)';
  dragging: boolean = false;
  loaded: boolean = false;
  imageLoaded: boolean = false;
  imageSrc: string = '';

  ngOnInit(): void {}

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
  ) {
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
   // console.log('appBaseUrl', this.appBaseUrl);
  }

  close() {
    //this.bsModalRef.hide();
    this.handleCancel.emit(true)
  }

  filesDropped(files: any): void {
    this.files = files;
   console.log(files.size + 'size');
  }

  saveFile() {
    this.savingFileMessage = "Saving File..."
    console.log(this.files)
    const fileName = this.files.name.replace(/\s+/g, "");
    const newFile = new File(
      [this.files],
      fileName,
      {
        type :this.files.type
              }
    )
    // this.files.name = this.files.name.replace(/\s+/g, "");
    console.log(newFile)
    this.formDataService.uploadFile(newFile).subscribe(response => {
     // console.log('saveFile', response);
      let fileID = response.Response.Data.FileID;
      this.handleFileUpload.emit(response.Response.Data);
      this.savingFileMessage = "File Saved"
    });

  }

  getFIleById(fileID: any) {
   // console.log('uploadfile fileID', fileID);
    this.formDataService.getFilesByID([fileID]).subscribe(response => {
     // console.log('getFIleById', response.Response.Data.URL);
    });
  }

  //--------
  handleDragEnter() {
    this.dragging = true;
  }

  handleDragLeave() {
    this.dragging = false;
  }

  handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }

  handleImageLoad() {
    this.imageLoaded = true;
  }

  handleInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    
    // Early return if no file selected
    if (!file) {
      return;
    }
    
    this.files = file;

    const reader = new FileReader();
    this.loaded = false;
    
    let extension = file.name.split(".").pop();

    if(!this.isUploadAllowed(extension)){
      alert('Invalid file format');
      // Reset the file input and display
      e.target.value = '';
      const fileChosen = document.getElementById('file-chosen');
      if (fileChosen) {
        fileChosen.textContent = 'No file chosen';
      }
      return;
    }
    
    const fileSizeInMB = file.size / (1024 * 1024);
    let maxFileSize = this.maxFileSize.split(" ")[0];
    if (fileSizeInMB >= maxFileSize) {
      alert('File size is more than '+ this.maxFileSize);
      // Reset the file input and display
      e.target.value = '';
      const fileChosen = document.getElementById('file-chosen');
      if (fileChosen) {
        fileChosen.textContent = 'No file chosen';
      }
      return;
    }

    reader.onload = this._handleReaderLoaded.bind(this);
    
    // Update the file name display immediately
    const fileChosen = document.getElementById('file-chosen');
    if (fileChosen) {
      fileChosen.textContent = file.name;
    }
    
    reader.readAsDataURL(file);
 }

  _handleReaderLoaded(e) {
    const reader = e.target;
    this.imageSrc = reader.result;
    this.loaded = true;
    const files: any = [];
  }

  isUploadAllowed(ext: string){
    let allowed = false;
    let index = this.allowedFileTypes.findIndex(item => item.ext === ext.toLowerCase());
    if (index !== -1) {
      allowed = true;
    }
    return allowed;
  }
}

